import AudioManager from "../../../../manager/audio_manager";
import Utility from "../../../../utility/utility";


const { ccclass, property } = cc._decorator;

const const_soundPath: string = 'package/slot/sound/'

export default class SlotTableSound {

    static playBgm() {
        let soundName = "bgm/slot"
        AudioManager.instance.playMusic(const_soundPath + soundName, true)
    }
    static playFreeBgm() {
        let soundName = "freespin_bgm"
        AudioManager.instance.playMusic(const_soundPath + soundName, true)
    }
    static playSoundEffect(onFinish?, onStart?, loop?) {
        let soundName = "slot_hailang"
        if (!AudioManager.instance.isSoundOpen()) {
            return
        }
        AudioManager.instance.playSound(const_soundPath + soundName, loop, onFinish, onStart)
    }
    static setMusicVolume(valume) {
        AudioManager.instance.setMusicVolume(valume)
    }
    static pauseBgm() {
        if (!AudioManager.instance.isMusicOpen()) {
            return
        }
        AudioManager.instance.pauseMusic()
    }
    static resumeBgm() {
        if (!AudioManager.instance.isMusicOpen()) {
            return
        }
        AudioManager.instance.resumeMusic()
    }
    static playNumberCycleSound(onStart?, onFinish?, loop?) {
        let soundName = '通用物品获取'
        AudioManager.instance.playSound(const_soundPath + soundName, loop, onFinish, onStart)
    }
    static playGoldSound() {
        let soundName = 'snd_multipot_coin'
        this.playSound(const_soundPath + soundName)
    }
    static playSpinSound(index, onFinish?, onStart?, loop?) {
        let soundName = `snd_spin_reel_${index}`
        this.playSound(const_soundPath + soundName, onFinish, onStart, loop)
    }
    static playCycleStopSound(index, onFinish?, onStart?) {
        let soundName = 'slots_reel_stop_' + index
        this.playSound(const_soundPath + soundName, onFinish, onStart)
    }
    static playOfkindSound() {
        let soundName = 'slots_combination'
        this.playSound(const_soundPath + soundName)
    }
    static playBigWinSound() {
        let soundName = 'slots_big_win'
        this.playSound(const_soundPath + soundName)
    }
    static playSuperWinSound() {
        let soundName = 'slots_super_win'
        this.playSound(const_soundPath + soundName)
    }
    static playHugeWinSound() {
        let soundName = 'slots_huge_win'
        this.playSound(const_soundPath + soundName)
    }
    static playRewardLineSound() {
        let soundName = 'slots_lines'
        this.playSound(const_soundPath + soundName)
    }
    static playSpecialIconSound() {
        let soundName = 'slots_arthurs_camelot_scatter_item_show'
        this.playSound(const_soundPath + soundName)
    }
    static playFreeSpinCycle( onFinish?, onStart?, loop?) {
        let soundName = 'slots_reel_start_accelerate'
        this.playSound(const_soundPath + soundName, onFinish, onStart, loop)
    }
    static playFreeSpinNone() {
        let soundName = 'slots_reel_stop_accelerate'
        this.playSound(const_soundPath + soundName)
    }
    static playFreeSpinHave() {
        let soundName = 'slots_scatter_highlight'
        this.playSound(const_soundPath + soundName)
    }
    static playFreeSpinReward(onFinish?, onStart?, loop?) {
        let soundName = 'slots_free_spins'
        this.playSound(const_soundPath + soundName,onFinish, onStart, loop)
    }
    static playFreeSpinEnd() {
        let soundName = 'slots_payout'
        this.playSound(const_soundPath + soundName)
    }
    static playFreeSpinCoin() {
        let soundName = 'slots_win_coins'
        this.playSound(const_soundPath + soundName)
    }
    static playBtnClickSound(name) {
        let soundName = ""
        if (name == "StartBtn") {
            soundName = "slots_button_spin"
        } else if (name == "StopBtn") {
            soundName = "slots_button_stop"
        } else if (name == "AddBtn") {
            soundName = "slots_button_add_bet"
        } else if (name == "ReduceBtn") {
            soundName = "slots_button_limit_bet"
        } else if (name == "InfoBtn" || name == "BtnClose") {
            soundName = "slots_button_paytable"
        } else if (name == "MaxBtn") {
            soundName = "slots_button_max_bet"
        } else if (name == "AutoBtn") {
            soundName = "slots_button_autospin"
        } else if (name == "BtnLeft" || name == "BtnRight") {
            soundName = "videopoker_button_click"
        }
        this.playSound(const_soundPath + soundName)
    }


    static playSound(fullPath: string, onFinish?: Function, onStart?: Function, loop?) {
        AudioManager.instance.playSound(fullPath, loop, onFinish, onStart)
    }

    static playMusic(fullPath: string) {
        AudioManager.instance.playMusic(fullPath, false)
    }

    static stopSound(id: number) {
        AudioManager.instance.stopSound(id)
    }
    static pauseSound(id: number) {
        AudioManager.instance.pauseSound(id)
    }
    static resumeSound(id: number) {
        if (!AudioManager.instance.isSoundOpen()) {
            return
        }
        AudioManager.instance.resumeSound(id)
    }

    static stopBgm() {
        AudioManager.instance.stopAllMusic()
    }



    private getRandomIndex(under: number = 0, over: number = 0) {
        return Utility.getIntRandom(under, over)
    }
}